export default {
  rate_plan_policies: []
}
